import { HttpParams } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { CollectionService } from '../../../core/services/collection.service';
import { AlertComponent } from '../../partials/content/crud';

@Component({
  selector: 'kt-dialog-annulment',
  templateUrl: './dialog-annulment.component.html',
  styleUrls: ['./dialog-annulment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogAnnulment implements OnInit {
    annulmentForm: FormGroup;
    fileName = new FormControl();

    @ViewChild('fileNameInput') fileNameInput: ElementRef;

    error : boolean;
    constructor(
        private fb: FormBuilder,
        private cdr: ChangeDetectorRef,
        public dialogRef: MatDialogRef<DialogAnnulment>,
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private collectionService: CollectionService,
        private _snackBar: MatSnackBar,
        private dialog: MatDialog
    ) {
    }

    ngOnInit() {
        this.error = false;
        this.annulmentForm = this.fb.group({
            fileName: ["",Validators.required],
        });
    }

     private openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 3000,
        });
    }

    anularPago(){
        const fileName = this.annulmentForm.controls.fileName.value;
        this.collectionService.deletePaymentWithNameFile(fileName)
        .subscribe(response => {
            if(response == true){
                this.openSnackBar('Archivo eliminado con exito!', 'Ok'); 
                this.dialogRef.close(false);
            }else{
                this.error = true; 
                this.cdr.detectChanges()
            }
        }, error => {this.error = true; this.cdr.detectChanges()})
    }
  
    onNoClick(): void {
        this.dialogRef.close(false);
    }

    isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.annulmentForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}

    
}
